import React, { useState } from 'react';
import { Form, Card, Space, DatePicker } from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
// import localStyles from './index.module.less';
import CustomTable from 'common/Content/CustomTable';
import CustomButton from '@/common/CustomButton';
import Layout from '@/common/Layout';
import { history } from 'app/history';
import { useGetDispensingAidsListQuery } from '../../redux/apiSlice';
import moment from 'moment';
import Spinner from '../../../../common/Spinner';
import { EditOutlined } from '@ant-design/icons';
const { RangePicker } = DatePicker;

const AdminPage = () => {
  const [form] = Form.useForm();

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  let totalRecords;

  const { data, error, isLoading } = useGetDispensingAidsListQuery({
    page,
    per_page: perPage,
    from_date: fromDate,
    to_date: toDate
  });

  console.log('data ====', data);

  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      ellipsis: true,
      // width: '200px',
      render: (_, record) => {
        return record?.date ? moment(record?.date).format('DD-MMM-YYYY') : '';
      }
    },
    {
      title: 'Equipment / Accessory Name',
      dataIndex: 'equipment',
      key: 'equipment',
      ellipsis: true,
      // width: '200px',
      render: (_, record) => {
        return record?.dispensing_aids_equipment_accessories_name_master
          ?.equipment_acc
          ? record.dispensing_aids_equipment_accessories_name_master
              .equipment_acc
          : '';
      }
    },
    {
      title: 'ID#',
      dataIndex: 'equip_id',
      key: 'equip_id',
      ellipsis: true,
      // width: '200px',
      render: (_, record) => {
        return record?.dispensing_aids_id_master?.equip_id
          ? record.dispensing_aids_id_master.equip_id
          : '';
      }
    },
    {
      title: 'In-House / Product Batch #',
      dataIndex: 'in_house_product_batch',
      key: 'in_house_product_batch',
      ellipsis: true
      // width: '200px',
    },
    {
      title: 'Cleaned by (User id & Date)',
      dataIndex: 'cleaned_by',
      key: 'cleaned_by',
      ellipsis: true,
      // width: '200px',
      render: (_, record) => {
        let result = '';
        record?.cleaned_by_user_id ? (result = record.cleaned_by_user_id) : '';
        record?.cleaned_by_user_date
          ? (result += ` (${moment(record?.cleaned_by_user_date).format(
              'DD-MMM-YYYY'
            )})`)
          : '';
        return result;
      }
    },
    {
      title: 'Remarks',
      dataIndex: 'remarks',
      key: 'remarks',
      ellipsis: true
      // width: '200px',
    },
    {
      title: 'Action',
      dataIndex: 'received_by',
      key: 'received_by',
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
      render: (_, record) => (
        <EditOutlined
          onClick={() =>
            history.push(`/log-books-dispensing-aids-create?id=${record?.id}`)
          }
        />
      )
    }
  ];

  let content;
  if (isLoading) {
    console.log('Loading.....');
    content = <Spinner />;
  } else if (data) {
    console.log(data?.pagination?.total_records);
    totalRecords = data?.pagination?.total_records;
    content = (
      <Layout sider={false}>
        {/* <div className={localStyles.heading1}>
          <h1>Overview</h1>
          <h4>Your current requests summary and other activities</h4>
        </div> */}
        <Form form={form} layout="vertical">
          <Card
            title={<span>Cleaning Record of Dispensing Aids</span>}
            className={`${styles.cardStyles_approver}`}
            extra={
              <Space>
                <RangePicker
                  onChange={(e) => {
                    console.log(e[0]._d);
                    setFromDate(moment(e[0]._d).startOf('day').format());
                    setToDate(moment(e[1]._d).endOf('day').format());
                    setPage(1);
                  }}
                />
                <CustomButton
                  className={styles.inwardButton}
                  onClick={() =>
                    history.push('/log-books-dispensing-aids-create')
                  }
                  type="primary"
                >
                  Create
                </CustomButton>
              </Space>
            }
          >
            <div className={`${styles.table_container}`}>
              <CustomTable
                columns={columns}
                dataSource={data.data}
                showPaginationMeta
                pagination={{
                  size: 'small',
                  pageSize: perPage,
                  current: page,
                  total: totalRecords,
                  onChange: (page, pageSize) => {
                    setPage(page);
                    setPerPage(pageSize);
                  }
                }}
              />
            </div>
          </Card>
          <br />
          <FormItem className="text-center">
            <CustomButton
              className={styles.inwardButton}
              onClick={() => history.push('log-books')}
              type="primary"
            >
              Back to Home
            </CustomButton>
          </FormItem>
        </Form>
      </Layout>
    );
  } else if (error) {
    console.log(error);
    content = 'Something went wrong!';
  }

  return <>{content}</>;
};
export default AdminPage;
